'use client'

import { useTranslations } from 'next-intl'
import { DisclaimerWrapper } from './DisclaimerWrapper'

export const GenericPaymentDisclaimer = () => {
  const t = useTranslations()

  return <DisclaimerWrapper>{t('disclaimerPayInGeneric')}</DisclaimerWrapper>
}
